import WixSDK from 'shared/utils/wix-sdk';
import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { getVideoCards } from 'api/public/video-cards/video-cards';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/dist/video-cards/types';
import {
  buildChannelCardsDeeplinkUrl,
  buildVideoCardsDeeplinkUrl,
} from 'api/widgets';

const ACTIONS = createAsyncActions('SERVER.VIDEO-CARDS.GET');
const { START, SUCCESS, FAIL } = ACTIONS;

const deeplinkCardTypes = [
  VIDEO_CARD_TYPES.CHANNEL,
  VIDEO_CARD_TYPES.VIDEO,
  VIDEO_CARD_TYPES.RECENT_VIDEO,
];

const hasDeeplink = card => _.includes(deeplinkCardTypes, card.type);

const appendDeeplinks = (cardsData, fallbackUrl) =>
  _.map(cardsData, card =>
    hasDeeplink(card)
      ? {
          ...card,
          url: card.actionItemId
            ? buildVideoCardsDeeplinkUrl({
                channelId: card.actionListId,
                videoId: card.actionItemId,
                instance: WixSDK.Utils.getInstance(),
                fallbackUrl,
              })
            : buildChannelCardsDeeplinkUrl({
                channelId: card.actionListId,
                instance: WixSDK.Utils.getInstance(),
                fallbackUrl,
              }),
        }
      : card,
  );

export const NAMES = ACTIONS.NAMES;

export default function(listId, itemId) {
  return function(dispatch) {
    const params = { id: itemId };

    dispatch(START(params));

    return Promise.all([getVideoCards(listId, itemId), WixSDK.getSiteUrl()])
      .then(([response, siteUrl]) => appendDeeplinks(response.data, siteUrl))
      .then(data => {
        dispatch(SUCCESS(params, data));
        return data;
      })
      .catch(errorResponse => {
        dispatch(
          FAIL(params, errorResponse, {
            analytics: {
              type: 'error',
              name: 'shared.video-cards.get',
            },
          }),
        );
      });
  };
}
